import { z } from 'zod';

export const phoneNumberValidator = (_shape?: z.ZodTypeAny) =>
	z
		.string()
		.nullish()
		.transform(v => v ?? '')
		.pipe(
			z
				.string()
				.trim()
				.refine(
					s => {
						if (s === '') return true;
						if (/[a-zA-Z]/.test(s)) return false;
						if (/[^0-9+\-().\s]/.test(s)) return false;
						if (!/[0-9]/.test(s)) return false;

						return true;
					},
					{ message: 'Invalid phone number format' }
				)
		);
